import { render, staticRenderFns } from "./PagamentosConsulta.vue?vue&type=template&id=2b8253e4"
import script from "./PagamentosConsulta.vue?vue&type=script&lang=js"
export * from "./PagamentosConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports